<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <!-- 收起状态 -->
              <template v-if="!advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24">
                  <a-form-item label="项目分组" prop="projectGroup">
                    <a-input
                      v-model:value="queryParam.projectGroup"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24">
                  <a-form-item label="项目代码" prop="projectCode">
                    <a-input
                      v-model:value="queryParam.projectCode"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <!-- 收起状态下的按钮 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button reset-button"
                        >重置</a-button
                      >
                      <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                        展开
                        <DownOutlined />
                      </a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </template>

              <!-- 展开状态 -->
              <template v-else>
                <!-- 第一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="项目分组" prop="projectGroup">
                    <a-input
                      v-model:value="queryParam.projectGroup"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="项目代码" prop="projectCode">
                    <a-input
                      v-model:value="queryParam.projectCode"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="项目名称" prop="chineseName">
                    <a-input
                      v-model:value="queryParam.chineseName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="甲方联系人" prop="leader">
                    <a-input
                      v-model:value="queryParam.leader"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>

                <!-- 第二行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="甲方联系电话" prop="phone">
                    <a-input
                      v-model:value="queryParam.phone"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="是否自动记薪" prop="needSalary">
                    <a-select
                      v-model:value="queryParam.needSalary"
                      placeholder="请选择"
                      style="width: 100%"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['whether_to_calculate_salary']"
                        :key="index"
                        :value="d.dictValue"
                        >{{ d.dictLabel }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="项目主管" prop="supervisorName">
                    <a-input
                      v-model:value="queryParam.supervisorName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item label="项目状态" prop="projectStatus">
                    <a-select
                      v-model:value="queryParam.projectStatus"
                      placeholder="请选择"
                      style="width: 100%"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['project_status']"
                        :key="index"
                        :value="d.dictValue"
                        >{{ d.dictLabel }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>

                <!-- 第三行：按钮行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item"></a-col>
                <!-- <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item"></a-col> -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item"></a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="24" class="search-row-item">
                  <a-form-item>
                    <span class="table-page-search-submitButtons">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button reset-button"
                        >重置</a-button
                      >
                      <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                        收起
                        <UpOutlined />
                      </a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>

        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="refreshData"
            v-hasPermi="['user:projectInfo:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button type="primary" @click="handleAddClick" v-hasPermi="['user:projectInfo:add']" class="add-button">
            <PlusOutlined />新增
          </a-button>
          <a-button
            @click="importExcelRef?.importExcelHandleOpen()"
            v-hasPermi="['user:projectInfo:import']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入
          </a-button>
          <a-button
            @click="handleExport"
            v-hasPermi="['user:projectInfo:export']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['user:projectInfo:remove']"
            class="no-border-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <a-button
            @click="handleImportTemplate"
            v-hasPermi="['user:projectInfo:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />下载模板
          </a-button>
        </div>

        <!-- 上传文件 -->
        <import-excel ref="importExcelRef" @ok="getList" />
        <!-- 增加修改 -->
        <create-form ref="createFormRef" @ok="getList" />

        <!-- 数据展示 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 2000 }"
            class="optimized-table"
          >
            <template #bodyCell="{ column, text, record }">
              <template v-if="column.dataIndex === 'companyName'">
                <span>
                  {{ record.companyName || record.companyAbbreviation || record.companyCode || '-' }}
                </span>
              </template>
              <template v-else-if="column.dataIndex === 'projectStatus'">
                <span>
                  {{ getDictLabel(dict.type['project_status'], record.projectStatus) }}
                </span>
              </template>
              <template v-else-if="column.dataIndex === 'needSalary'">
                <span>
                  {{ getDictLabel(dict.type['whether_to_calculate_salary'], record.needSalary) }}
                </span>
              </template>
              <template v-else-if="column.dataIndex === 'operation'">
                <div class="table-action-buttons">
                  <a
                    @click="createFormRef?.handleUpdate(record, undefined)"
                    v-hasPermi="['user:projectInfo:edit']"
                    class="edit-link"
                  >
                    编辑
                  </a>
                  <span class="action-divider">|</span>
                  <a @click="handleDelete(record)" v-hasPermi="['user:projectInfo:remove']" class="delete-link">
                    删除
                  </a>
                </div>
              </template>
            </template>
          </a-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script setup>
import { ref, reactive, computed, onMounted, markRaw } from 'vue'
import { useStore } from 'vuex'
import { Modal, message } from 'ant-design-vue'
import { pageProjectInfo, delProjectInfo } from '@/api/user/projectInfo'
import { getDicts } from '@/api/system/dict/data'
import { download } from '@/utils/request'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import {
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'

const store = useStore()

// 字典数据
const dictProjectStatus = ref([])
const dictWhetherToCalculateSalary = ref([])

// 初始化字典
const initDicts = async () => {
  try {
    const dictTypes = ['project_status', 'whether_to_calculate_salary']
    for (const type of dictTypes) {
      try {
        const res = await getDicts(type)
        if (res.data && Array.isArray(res.data)) {
          switch (type) {
            case 'project_status':
              dictProjectStatus.value = res.data
              break
            case 'whether_to_calculate_salary':
              dictWhetherToCalculateSalary.value = res.data
              break
          }
        }
      } catch (error) {
        console.warn(`加载字典 ${type} 失败:`, error)
      }
    }
  } catch (error) {
    console.error('初始化字典失败:', error)
  }
}

// 响应式数据
const list = ref([])
const selectedRowKeys = ref([])
const selectedRows = ref([])
const advanced = ref(false)
const multiple = ref(true)
const ids = ref([])
const loading = ref(false)
const total = ref(0)
const jumpPage = ref(1)
const queryParam = reactive({
  projectCode: null,
  projectGroup: null,
  chineseName: null,
  leader: null,
  phone: null,
  needSalary: null,
  supervisorName: null,
  projectStatus: null,
  pageNum: 1,
  pageSize: 10,
})

// 表格列配置
const columns = markRaw([
  {
    title: '序号',
    dataIndex: 'id',
    align: 'center',
    width: 80,
    customRender: ({ index }) => {
      return (queryParam.pageNum - 1) * queryParam.pageSize + index + 1
    },
  },
  {
    title: '项目分组',
    dataIndex: 'projectGroup',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目代码',
    dataIndex: 'projectCode',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目名称(中文名称)',
    dataIndex: 'chineseName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '所属公司',
    dataIndex: 'companyName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '甲方联系人',
    dataIndex: 'leader',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '甲方联系电话',
    dataIndex: 'phone',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '是否启用自动记薪',
    dataIndex: 'needSalary',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目主管',
    dataIndex: 'supervisorName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目状态',
    dataIndex: 'projectStatus',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 200,
    fixed: 'right',
    align: 'center',
  },
])

// 组件引用
const createFormRef = ref(null)
const importExcelRef = ref(null)

// 计算属性 - tableSize
const tableSize = computed({
  get() {
    return store.state.app.tableSize
  },
  set(value) {
    store.commit('app/SET_TABLE_SIZE', value)
  },
})

// 计算属性 - tableBordered
const tableBordered = computed(() => store.state.app.tableBordered)

// 计算属性 - submitButtonStyle
const submitButtonStyle = computed(() => {
  return {}
})

// 字典对象（用于模板）
const dict = computed(() => ({
  type: {
    project_status: dictProjectStatus.value,
    whether_to_calculate_salary: dictWhetherToCalculateSalary.value,
  },
}))

// 获取字典标签
const getDictLabel = (dictList, value) => {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  if (!dictList || !Array.isArray(dictList) || dictList.length === 0) {
    return String(value)
  }

  // 将值转换为数字和字符串两种形式进行匹配
  const valueNum = typeof value === 'number' ? value : Number(value)
  const valueStr = String(value)

  const dictItem = dictList.find(
    (item) =>
      item.dictValue === valueStr ||
      item.dictValue === valueNum ||
      String(item.dictValue) === valueStr ||
      Number(item.dictValue) === valueNum
  )

  return dictItem ? dictItem.dictLabel : String(value)
}

// 方法
const getList = async () => {
  try {
    loading.value = true
    const response = await pageProjectInfo(queryParam)
    list.value = response.data.records || []
    total.value = response.data.total || 0
    jumpPage.value = queryParam.pageNum
  } catch (error) {
    console.error('获取项目信息列表失败:', error)
    list.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

const refreshData = () => {
  getList()
}

const handleQuery = () => {
  queryParam.pageNum = 1
  getList()
}

const resetQuery = () => {
  Object.assign(queryParam, {
    projectCode: null,
    projectGroup: null,
    chineseName: null,
    leader: null,
    phone: null,
    needSalary: null,
    supervisorName: null,
    projectStatus: null,
    pageNum: 1,
    pageSize: 10,
  })
  handleQuery()
}

const onShowSizeChange = (current, pageSize) => {
  if (loading.value) return
  queryParam.pageSize = pageSize
  queryParam.pageNum = 1
  jumpPage.value = 1
  getList()
}

const changeSize = (current, pageSize) => {
  if (loading.value) return
  queryParam.pageNum = current
  queryParam.pageSize = pageSize
  jumpPage.value = current
  getList()
}

const handleJumpPage = () => {
  if (jumpPage.value && jumpPage.value >= 1) {
    const maxPage = Math.ceil(total.value / queryParam.pageSize)
    if (jumpPage.value > maxPage) {
      jumpPage.value = maxPage
    }
    queryParam.pageNum = jumpPage.value
    getList()
  }
}

const onSelectChange = (keys, rows) => {
  selectedRowKeys.value = keys
  selectedRows.value = rows
  ids.value = rows.map((item) => item.id)
  multiple.value = !keys.length
}

const toggleAdvanced = () => {
  advanced.value = !advanced.value
}

const handleDelete = (row) => {
  // 如果传入row，则添加到ids中
  if (row && row.id) {
    ids.value = [row.id]
  }
  const deleteIds = row && row.id ? row.id : ids.value

  // 获取要删除的项目名称
  let projectNames = []
  if (row && row.id) {
    // 单条删除
    projectNames = [row.chineseName || '未知项目']
  } else {
    // 批量删除
    projectNames = selectedRows.value.map((item) => item.chineseName || '未知项目')
  }
  const projectNamesText = projectNames.length > 0 ? projectNames.join('、') : '未知项目'

  Modal.confirm({
    title: '确认删除所选中数据?',
    content: `当前选中项目名称为：${projectNamesText} 的数据`,
    onOk: async () => {
      try {
        const data = ids.value.map((id) => ({ id }))
        await delProjectInfo(data)
        onSelectChange([], [])
        getList()
        message.success('删除成功', 3)
      } catch (error) {
        message.error('删除失败', 3)
      }
    },
    onCancel: () => {
      // 取消时清空删除ids列表
      ids.value = []
    },
  })
}

const handleExport = () => {
  // 判断是否有选中的数据
  const hasSelected = selectedRowKeys.value && selectedRowKeys.value.length > 0
  const confirmContent = hasSelected
    ? `当前已选中 ${selectedRowKeys.value.length} 条数据，是否只导出选中的数据？`
    : '此操作将导出当前条件下所有有权限的数据'

  Modal.confirm({
    title: '是否确认导出?',
    content: confirmContent,
    onOk: () => {
      const params = {
        ...queryParam,
      }
      // 如果有选中的数据，传入ID列表
      if (hasSelected) {
        params.projectIds = selectedRowKeys.value
      }
      download('user/project-info/export', params, `项目信息_${new Date().getTime()}.xlsx`)
    },
  })
}

// 下载模板按钮处理
const handleImportTemplate = () => {
  download('user/project-info/importTemplate', {}, `项目信息导入模板_${new Date().getTime()}.xlsx`)
}

// 新增按钮处理
const handleAddClick = () => {
  if (createFormRef.value) {
    createFormRef.value.handleAdd()
  }
}

// 生命周期
onMounted(async () => {
  await initDicts()
  getList()
})
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 100px;
  min-width: 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100px;
  text-align: right;
}

/* 搜索栏 FormItem 布局：左侧文字固定 100px，右侧输入区域自适应 */
.table-page-search-wrapper :deep(.ant-form-item) {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-label) {
  flex: 0 0 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 auto;
  margin-left: 8px;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
/* 覆盖所有边框相关属性 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper > .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper input.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式 - 统一宽度 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 所有输入框的外层容器（ant-input-affix-wrapper）样式 - allow-clear 时会自动包裹 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 输入框内部的 input 元素 - 必须去掉边框避免嵌套 - 最高优先级 */
/* 使用更具体的选择器确保覆盖所有情况 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 如果没有被 affix-wrapper 包裹的纯 input（理论上很少见，但保留兼容性） */
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input:not(.ant-input-affix-wrapper .ant-input)) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 强制去掉所有在 affix-wrapper 内的 input 边框 - 使用最高优先级选择器 */
/* 覆盖所有可能的边框属性和状态 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button[disabled] {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.no-border-button[disabled]:hover,
.no-border-button[disabled]:focus {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

/* 重置按钮样式 */
.reset-button {
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.reset-button:hover,
.reset-button:focus {
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 导入导出按钮样式 - 参照重置按钮 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.import-export-button:hover,
.import-export-button:focus {
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  background: transparent !important;
  color: #165dff !important;
  border: none !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  background: transparent !important;
  color: #165dff !important;
  border: none !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}

.table-action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 删除按钮颜色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

.optimized-table :deep(.ant-table-tbody > tr:hover > td:last-child) {
  background-color: #f5f5f5 !important;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

/* 新增样式 */
.button-row {
  display: flex;
  align-items: center;
  padding-top: 16px;
}

.button-row :deep(.ant-form-item) {
  margin-bottom: 0;
}

/* 搜索行项样式 */
.search-row-item {
  margin-bottom: 0;
}

/* 优化搜索栏响应式布局 */
@media (max-width: 768px) {
  .search-row-item {
    margin-bottom: 12px;
  }

  .table-page-search-wrapper :deep(.ant-col-sm-12) {
    margin-bottom: 12px;
  }

  .table-page-search-wrapper :deep(.ant-form-item) {
    display: flex;
    flex-direction: column;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: 100% !important;
    text-align: left !important;
    margin-bottom: 4px;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: 100% !important;
    text-align: left !important;
    padding-right: 0 !important;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control) {
    width: 100% !important;
    margin-left: 0 !important;
  }

  .table-page-search-wrapper :deep(.ant-input),
  .table-page-search-wrapper :deep(.ant-input-affix-wrapper),
  .table-page-search-wrapper :deep(.ant-select),
  .table-page-search-wrapper :deep(.ant-picker) {
    width: 100% !important;
  }

  .button-row {
    padding-top: 8px;
  }
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>